export default "__VITE_ASSET__BA26j7zI__"